var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPcCircleArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11C0 17.0751 4.92487 22 11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11Z",
    fill: "#FF6B00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 0.5C5.20101 0.5 0.5 5.20101 0.5 11C0.5 16.799 5.20101 21.5 11 21.5C16.799 21.5 21.5 16.799 21.5 11C21.5 5.20101 16.799 0.5 11 0.5Z",
    stroke: "black",
    strokeOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60477 8.00012C6.45018 8.00012 6.29332 8.06449 6.17606 8.19001C5.94131 8.44129 5.94131 8.8568 6.17606 9.10807L10.5687 13.8101C10.682 13.9315 10.842 14 10.9974 14C11.1513 14 11.3047 13.94 11.4261 13.8101L15.8127 9.1141C16.0584 8.86652 16.0616 8.44121 15.8268 8.18993C15.5921 7.93866 15.2039 7.93866 14.9692 8.18993L14.969 8.19009L11.0052 12.4416L7.03333 8.18989C6.91585 8.06413 6.75899 8 6.60462 8L6.60477 8.00012Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPcCircleArrowDown);
export default __webpack_public_path__ + "static/media/PC_circle_arrow_down.ed7bf10aee616139c546eb1d71ed9c81.svg";
export { ForwardRef as ReactComponent };